export default __webpack_public_path__ + "static/media/person_2@3x.7b06d2c9.png";